import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { LoadingSpinner } from './shared/LoadingSpinner';

interface ProtectedMasterRouteProps {
  children: React.ReactNode;
}

/**
 * Guard de rota para usuários com role `master`.
 * Usado para proteger as telas de gerenciamento de organização (painel admin,
 * hoje embutido no app principal em /organization — ver OrganizationManagement.tsx).
 * A isolação de dados por organização é garantida pelo backend — os endpoints
 * usados (/organizations/my, /users/, etc.) já retornam apenas dados da org do usuário.
 */
export const ProtectedMasterRoute: React.FC<ProtectedMasterRouteProps> = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" text="Verificando permissões..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const isMaster = user?.user_role === 'master' || user?.role === 'master';

  if (!isMaster) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
